/* LovaCream — bandeau cookies (v22), branché sur l'API Customer Privacy de Shopify.
   Le choix est enregistré par Shopify lui-même (setTrackingConsent) : les pixels de Shopify et des applications
   (Meta, Google, TikTok…) le respectent. Google Consent Mode est aussi mis à jour si une balise gtag est présente. */
(function () {
  'use strict';
  var root = document.getElementById('lc-cookie');
  if (!root || window.LC_CONSENT_READY) return;
  window.LC_CONSENT_READY = true;

  var card = root.querySelector('.lc-cookie__card');
  var prefs = root.querySelector('#lc-cookie-prefs');
  var saveBtn = root.querySelector('[data-cookie-action="save"]');
  var customize = root.querySelector('[data-cookie-action="customize"]');
  var switches = root.querySelectorAll('[data-consent]');
  var api = null;
  var lastFocus = null;

  function gtagUpdate(c) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      analytics_storage: c.analytics ? 'granted' : 'denied',
      ad_storage: c.marketing ? 'granted' : 'denied',
      ad_user_data: c.marketing ? 'granted' : 'denied',
      ad_personalization: c.marketing ? 'granted' : 'denied'
    });
  }

  function current() {
    var v = (api && api.currentVisitorConsent) ? (api.currentVisitorConsent() || {}) : {};
    var local = null;
    try { local = JSON.parse(localStorage.getItem('lc-consent') || 'null'); } catch (e) {}
    return {
      decided: !!(v.analytics || v.marketing || v.preferences) || !!(local && local.how),
      analytics: v.analytics === 'yes',
      marketing: v.marketing === 'yes',
      preferences: v.preferences === 'yes'
    };
  }

  function showPrefs(on) {
    prefs.hidden = !on;
    saveBtn.hidden = !on;
    customize.setAttribute('aria-expanded', on ? 'true' : 'false');
    customize.textContent = on ? 'Masquer le détail' : 'Personnaliser';
    root.classList.toggle('has-prefs', on);
  }

  function open(withPrefs) {
    var c = current();
    switches.forEach(function (s) { s.checked = !!c[s.dataset.consent]; });
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    document.documentElement.classList.add('lc-cookie-open');
    showPrefs(!!withPrefs);
    /* le focus va sur la carte, pas sur un bouton : aucun des deux choix n'est mis en avant */
    if (card) card.focus({ preventScroll: true });
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lc-cookie-open');
    window.LC_CONSENT_PENDING = false;
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('lc:consent-closed'));
  }

  function decide(c, how) {
    var payload = { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing };
    gtagUpdate(payload);
    try { localStorage.setItem('lc-consent', JSON.stringify({ how: how, date: new Date().toISOString(), v: 1 })); } catch (e) {}
    var done = false;
    function finish() { if (done) return; done = true; close(); }
    if (api && api.setTrackingConsent) {
      try { api.setTrackingConsent(payload, finish); } catch (e) { finish(); }
      setTimeout(finish, 900);
    } else {
      finish();
    }
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-action]');
    if (!b) return;
    var a = b.dataset.cookieAction;
    if (a === 'accept') decide({ analytics: true, marketing: true, preferences: true }, 'tout-accepter');
    else if (a === 'refuse') decide({}, 'tout-refuser');
    else if (a === 'customize') showPrefs(prefs.hidden);
    else if (a === 'save') {
      var c = {};
      switches.forEach(function (s) { c[s.dataset.consent] = s.checked; });
      decide(c, 'personnaliser');
    }
  });
  /* Échap = continuer sans accepter (même valeur qu'un refus) */
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') decide({}, 'echap-refus'); });

  /* « Gérer mes cookies » : bouton du pied de page, ou tout lien vers #cookies */
  document.addEventListener('click', function (e) {
    var l = e.target.closest('[data-lc-cookie-open], a[href$="#cookies"]');
    if (!l) return;
    e.preventDefault();
    open(true);
  });

  function start() {
    var c = current();
    if (c.decided) gtagUpdate(c);
    var mustShow = root.dataset.scope === 'auto'
      ? !!(api && api.shouldShowBanner && api.shouldShowBanner()) && !c.decided
      : !c.decided;
    var design = window.Shopify && window.Shopify.designMode;
    window.LC_CONSENT_PENDING = mustShow && !design;
    if (location.hash === '#cookies') open(true);
    else if (mustShow && !design) setTimeout(function () { open(false); }, 700);
  }

  function load() {
    if (window.Shopify && window.Shopify.customerPrivacy) { api = window.Shopify.customerPrivacy; return start(); }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) api = window.Shopify.customerPrivacy || null;
        start();
      });
    } else {
      start();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
